__turbopack_context__.v({
  "colorScheme--dark": "_7DACXW_colorScheme--dark",
  "colorScheme--light": "_7DACXW_colorScheme--light",
  "colorScheme--surface": "_7DACXW_colorScheme--surface",
  "colorScheme--warning": "_7DACXW_colorScheme--warning",
  "container": "_7DACXW_container",
  "disabled": "_7DACXW_disabled",
  "fontNormal": "_7DACXW_fontNormal",
  "hover--accent": "_7DACXW_hover--accent",
  "hover--none": "_7DACXW_hover--none",
  "hover--primary": "_7DACXW_hover--primary",
  "hover--warning": "_7DACXW_hover--warning",
  "size--lg": "_7DACXW_size--lg",
  "size--sm": "_7DACXW_size--sm",
  "textshadow": "_7DACXW_textshadow",
  "underlined": "_7DACXW_underlined",
});
